var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6137 32.1085L32.4172 12.1509C32.4622 11.032 31.913 9.97355 30.9714 9.35636L29.589 8.45255L24.4965 5.12063L24.3978 5.0556C24.3477 5.02268 24.2974 4.99171 24.2462 4.96243C24.2194 4.94708 24.1914 4.9321 24.1632 4.9171C23.5815 4.60253 22.9242 4.47756 22.2807 4.54639C21.8652 4.59002 21.4551 4.71394 21.0752 4.91964L14.1152 8.69192C13.1221 9.23073 12.4852 10.246 12.4403 11.3683L11.6371 31.3184C11.5965 32.3368 11.9789 33.274 12.6278 33.9642C13.1564 34.5277 13.8633 34.9268 14.6641 35.0715C14.8345 35.1025 15.0095 35.1221 15.1881 35.1298L16.8467 35.1952L27.768 35.627C29.8106 35.708 31.5324 34.1323 31.6137 32.1085ZM21.2059 13.1596C21.1479 13.1737 21.0915 13.1866 21.0347 13.197C21.01 13.2022 20.9837 13.2065 20.9591 13.2096C20.8777 13.221 20.7958 13.2278 20.7153 13.2301C20.6876 13.2314 20.661 13.2323 20.6346 13.2311C20.6068 13.2324 20.579 13.2316 20.5531 13.2296C19.6426 13.1895 18.8236 12.5738 18.575 11.6541C18.268 10.5163 18.9474 9.35014 20.094 9.04633C21.139 8.76813 22.2095 9.30343 22.6235 10.263C22.6511 10.3271 22.6769 10.3945 22.6991 10.4641C22.707 10.4934 22.7167 10.5214 22.7249 10.552C23.032 11.6876 22.3527 12.8538 21.2059 13.1596Z",
    fill: "url(#paint0_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6374 31.3181C11.5967 32.3365 11.9792 33.2737 12.628 33.9639C13.1567 34.5274 13.8636 34.9265 14.6644 35.0712C14.8348 35.1022 15.0098 35.1218 15.1884 35.1295L16.8469 35.1948L27.7683 35.6267C29.8109 35.7077 31.5326 34.132 31.614 32.1083L31.9894 22.7849L29.6245 14.037C29.5647 13.6895 29.4476 13.3491 29.271 13.031L28.4714 11.5927L25.4695 6.1935C25.2232 5.75065 24.8793 5.38177 24.4737 5.10506L24.4051 5.05983C24.3837 5.04602 24.3618 5.03292 24.3401 5.01962C24.3128 5.00256 24.2855 4.98509 24.2579 4.96914C24.208 4.94059 24.157 4.91408 24.1055 4.88815C24.0847 4.87748 24.0637 4.86745 24.0428 4.85728C23.5983 4.64532 23.1035 4.5326 22.5922 4.541L22.2793 4.54619C21.8644 4.58997 21.4548 4.7138 21.0754 4.91922L14.1155 8.6915C13.1224 9.23031 12.4855 10.2456 12.4405 11.3679L11.6374 31.3181ZM20.0942 9.04591C21.1392 8.76771 22.2098 9.30301 22.6237 10.2626C22.6514 10.3267 22.6771 10.394 22.6994 10.4637C22.7073 10.493 22.7169 10.521 22.7252 10.5516C23.0322 11.6873 22.353 12.8534 21.2062 13.1593C21.1482 13.1734 21.0918 13.1863 21.035 13.1967C21.0102 13.2018 20.984 13.2061 20.9594 13.2092C20.878 13.2206 20.7961 13.2274 20.7156 13.2298C20.6878 13.231 20.6613 13.2319 20.6348 13.2308C20.6071 13.232 20.5793 13.2312 20.5534 13.2293C19.6429 13.1892 18.8239 12.5735 18.5752 11.6538C18.2683 10.516 18.9476 9.34981 20.0942 9.04591Z",
    fill: "url(#paint1_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2709 13.0313L28.4714 11.593L25.4694 6.19385C24.893 5.15778 23.7859 4.52178 22.5922 4.54138L14.6604 4.67291C13.5284 4.69139 12.4886 5.29726 11.9222 6.26958L1.84994 23.5611C0.828168 25.3152 1.43461 27.5585 3.20529 28.5718L14.1086 34.8112C15.8784 35.8239 18.1416 35.2228 19.1634 33.4687L29.2394 16.1708C29.8042 15.2012 29.8152 14.0115 29.2709 13.0313ZM18.575 11.6536C18.2684 10.5167 18.9478 9.35034 20.0939 9.046C21.139 8.76846 22.2095 9.30376 22.6235 10.2625C22.6518 10.3271 22.677 10.3948 22.6989 10.4641C22.7075 10.4932 22.7167 10.5214 22.7248 10.5515C23.0319 11.6874 22.3525 12.8539 21.2059 13.1592C21.1487 13.1736 21.0919 13.1871 21.0351 13.1969C21.0102 13.202 20.9843 13.2066 20.9595 13.2093C20.8783 13.2209 20.7961 13.2282 20.7154 13.2304C20.6879 13.2316 20.6608 13.2319 20.6344 13.2313C20.6069 13.2325 20.5795 13.2313 20.5535 13.2297C19.6423 13.1895 18.8237 12.5736 18.575 11.6536Z",
    fill: "url(#paint2_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1638 33.4684C19.1638 33.4684 19.2084 33.3919 19.2906 33.2508L14.7455 16.4466C14.521 15.8774 14.0652 15.3959 13.3777 15.0024C11.8675 14.1382 10.7106 14.3956 9.90726 15.7748L8.45732 18.264C8.02242 19.0106 7.92956 19.6811 8.17275 20.2768L11.7345 33.4521L14.109 34.8109C15.8788 35.8236 18.1421 35.2225 19.1638 33.4684Z",
    fill: "url(#paint3_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9639 18.7166C20.8874 18.5085 20.7583 18.3523 20.5759 18.2479C20.3277 18.1059 20.0997 18.11 19.892 18.2602L6.48666 27.0663C6.39587 27.1191 6.32436 27.1903 6.27218 27.2799C6.1808 27.4368 6.16011 27.6155 6.21025 27.8163L7.00192 30.7448L14.1088 34.8117C15.8787 35.8245 18.1419 35.2234 19.1637 33.4693C19.1637 33.4693 20.4776 31.2136 22.1144 28.4037L23.1027 26.7069L20.9639 18.7166Z",
    fill: "url(#paint4_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9272 26.3976C18.7026 25.8283 18.2468 25.3468 17.5593 24.9533C16.0491 24.0891 14.8923 24.3466 14.0889 25.7257L12.639 28.2149C12.2041 28.9615 12.1112 29.6321 12.3544 30.2278L13.4992 34.4626L14.1088 34.8114C15.8787 35.8242 18.1419 35.2231 19.1636 33.469C19.1636 33.469 19.611 32.7009 20.3082 31.504L18.9272 26.3976Z",
    fill: "url(#paint5_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45706 18.2637L9.90701 15.7745C10.7104 14.3953 11.8672 14.1379 13.3774 15.0021C14.0649 15.3955 14.5208 15.8771 14.7453 16.4464C14.9693 17.0157 14.8726 17.6595 14.4547 18.3768L13.0047 20.866C12.5867 21.5837 12.0727 21.9886 11.4633 22.0807C10.8535 22.1729 10.205 22.0221 9.51748 21.6287C8.0072 20.7645 7.65373 19.6428 8.45706 18.2637ZM9.67819 18.925C9.30146 19.5718 9.46666 20.0973 10.1737 20.5019C10.8919 20.9129 11.4395 20.7952 11.8162 20.1485L13.2334 17.7155C13.61 17.069 13.4391 16.54 12.7209 16.129C12.0138 15.7244 11.472 15.8456 11.0954 16.492L9.67819 18.925ZM6.272 27.2787C6.32421 27.1891 6.39568 27.1179 6.48648 27.0651L19.8918 18.2591C20.0996 18.1089 20.3276 18.1047 20.5757 18.2467C20.7581 18.3511 20.8873 18.5074 20.9638 18.7155C21.04 18.9238 21.0261 19.1177 20.9217 19.2969C20.8693 19.3868 20.8001 19.4666 20.7143 19.5369L7.33779 28.2923C7.11212 28.447 6.85835 28.4441 6.57648 28.2828C6.38251 28.1718 6.26055 28.0158 6.21003 27.8152C6.15989 27.6144 6.18058 27.4357 6.272 27.2787ZM12.6186 28.2487L14.0796 25.7406C14.8891 24.3509 16.0489 24.0883 17.5592 24.9525C18.2467 25.3459 18.7018 25.8288 18.9247 26.4007C19.1474 26.9724 19.0483 27.62 18.6273 28.343L17.1663 30.8511C16.745 31.5743 16.2287 31.9831 15.6178 32.0778C15.0066 32.1724 14.3573 32.0229 13.6698 31.6295C12.1595 30.7653 11.8092 29.6383 12.6186 28.2487ZM13.837 28.9147C13.456 29.5688 13.619 30.0981 14.3261 30.5027C15.0443 30.9137 15.594 30.7923 15.975 30.1382L17.4088 27.6768C17.7896 27.023 17.621 26.4902 16.9028 26.0792C16.1956 25.6745 15.6516 25.7995 15.2708 26.4533L13.837 28.9147Z",
    fill: "url(#paint6_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.24 16.1709L25.815 22.0508L22.7764 10.811C22.7648 10.7249 22.7482 10.6381 22.7257 10.5522C22.7174 10.5217 22.7078 10.4936 22.6999 10.4643C22.6939 10.4448 22.6875 10.426 22.6798 10.4078C22.6635 10.3576 22.6441 10.309 22.6242 10.2632C22.2294 9.34895 21.2387 8.81968 20.2417 9.01375L22.8434 4.54719C23.8301 4.60708 24.7347 5.11302 25.2961 5.91632C25.3584 6.00458 25.4167 6.09802 25.4701 6.19419L28.4723 11.5932L29.2712 13.0318C29.8155 14.0112 29.8048 15.2012 29.24 16.1709Z",
    fill: "url(#paint7_linear_16658_74111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.181 11.9063C19.5079 11.5211 19.2772 10.6679 19.6658 10.0008L24.5932 1.54176C24.9818 0.874615 25.8426 0.646014 26.5157 1.03119C27.1888 1.41637 27.4194 2.26952 27.0308 2.93666L22.1035 11.3956C21.7149 12.0629 20.8541 12.2914 20.181 11.9063Z",
    fill: "url(#paint8_linear_16658_74111)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16658_74111",
    x1: 12.8454,
    y1: 11.9803,
    x2: 25.5531,
    y2: 25.8663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16658_74111",
    x1: 30.6603,
    y1: 26.6156,
    x2: 18.5047,
    y2: 19.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16658_74111",
    x1: 11.9934,
    y1: 6.99844,
    x2: 16.8079,
    y2: 25.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16658_74111",
    x1: 13.2434,
    y1: 24.9852,
    x2: 11.1305,
    y2: 17.0293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16658_74111",
    x1: 16.0763,
    y1: 32.4757,
    x2: 12.8233,
    y2: 20.2271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16658_74111",
    x1: 18.0473,
    y1: 37.2422,
    x2: 14.8279,
    y2: 25.1179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16658_74111",
    x1: 15.6699,
    y1: 19.6499,
    x2: 6.98464,
    y2: 34.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16658_74111",
    x1: 27.5658,
    y1: 17.3079,
    x2: 19.2487,
    y2: 3.28292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16658_74111",
    x1: 22.7495,
    y1: 6.12683,
    x2: 25.0139,
    y2: 7.44583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCodeIcon);
export default __webpack_public_path__ + "static/media/discount-code-icon.28ab772ed01232b3c881836575022227.svg";
export { ForwardRef as ReactComponent };